import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../../store/useAuthStore";
import { chatApi } from "../api/chatApi";
import { shouldRetryChatQuery } from "../lib/errors";
import { chatKeys } from "../lib/queryKeys";

/** Total unread across conversations — counted by the backend only (CONTRACT §4). */
export function useUnreadCount(): number {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data } = useQuery({
    queryKey: chatKeys.unread(),
    queryFn: () => chatApi.unreadCount(),
    enabled: isAuthenticated,
    staleTime: 60_000,
    retry: shouldRetryChatQuery,
  });
  return isAuthenticated ? (data?.total ?? 0) : 0;
}

/** «99+» like the rest of the badges; 0 → nothing. */
export function formatBadge(count: number): string | null {
  if (count <= 0) return null;
  return count > 99 ? "99+" : String(count);
}
